export default [
	// {
	// 	path: '/mudole',
	// 	name: 'mudole',		
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import('@/views/mudole.vue')
	// }
]